export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20horizontal%20composition%20of%20folded%20knitwear%20denim%20jacket%20canvas%20sneakers%20and%20leather%20accessories%20on%20long%20wooden%20bench%2C%20side%20window%20light%20creating%20dramatic%20diagonal%20shadows%2C%20warm%20amber%20and%20cream%20palette%2C%20editorial%20fashion%20photography%2C%20generous%20left%20side%20empty%20space&width=1920&height=800&seq=v2-cta-spread-bg&orientation=landscape"
        alt="Sugargoo Spreadsheet product showcase background"
        title="Browse Full Sugargoo Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/45"></div>

      <div className="relative z-10 mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col items-start max-w-xl">
          <h2 className="text-3xl md:text-5xl font-heading italic text-white leading-tight">
            Best Finds<br />
            Updated Daily
          </h2>
          <p className="mt-4 text-sm md:text-base text-white/75 max-w-md leading-relaxed">
            Fresh spreadsheet entries added every single day. Our community of experienced buyers constantly verifies links, removes dead listings, and surfaces the best QC-checked products across every category.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center gap-3 px-8 py-3.5 bg-white text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Browse Full Spreadsheet
            <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}